import React, { useState } from 'react';
import {
  ButtonGroup,
  DisplayText,
  TextStyle
} from '@superops/ui-design-system';
import { BrandingLogo } from '@nile/components';
import { FormattedMessage } from 'react-intl';
import {
  postMessageToWails,
  WAILS_EVENT
} from '@nile/components/src/Pages/SystemTrayChatPage/constants';
import { dompurifier } from '@nile/components/src/Utils/helpers';
import { isEmpty } from 'lodash';

const sendValue = (value) => {
  postMessageToWails({ eventName: WAILS_EVENT.PROMPT_RESPONSE, data: value });
};

function ChatPromptModal() {
  const [user, setUser] = useState({});
  const [message, setMessage] = useState('');

  window.addEventListener('message', (event) => {
    try {
      const data = event?.data?.data;
      const NotifyMessage = data?.NotifyMessage;
      const TechUser = data?.TechUser;
      if (TechUser) {
        const techUser = JSON.parse(TechUser);
        setUser({
          name: techUser?.name,
          clientName: techUser?.clientName
        });
        if (NotifyMessage) setMessage(NotifyMessage);
      }
    } catch (error) {}
  });

  if (isEmpty(user)) {
    return (
      <div className="agentLoadingText">
        <span className="agentLoader" />
      </div>
    );
  }

  return (
    <div className="full-height full-width bg-grey-gradient p20">
      <div className="flex fcol height80p text-white">
        <div className="flex g20 mb20">
          <div className="flex-center">
            <BrandingLogo hideName height="40" width="40" marginNone />
          </div>
          <div>
            <DisplayText element="h3" weight="Bold">
              <span className="text-white">{user?.name}</span>
            </DisplayText>
            <div className="flex text-white mbt5 g10">
              <span className="sub-action-section">
                <FormattedMessage id="ticket.details.chat.from" />
              </span>
              <DisplayText element="h3">
                <span className="text-white">
                  {user?.clientName || (
                    <FormattedMessage id="role.feature.client" />
                  )}
                </span>
              </DisplayText>
            </div>
          </div>
        </div>
        <div
          className="mb8 height80p scroll"
          dangerouslySetInnerHTML={{
            __html: dompurifier(message)
          }}
        />
      </div>
      <div className="height20p">
        <ButtonGroup spacing="loose" segmented={false} fullWidth>
          <div
            className="chatPromptButton flex-center acceptPrompt ptr"
            onClick={() => sendValue(true)}
          >
            <TextStyle>
              <span className="text-white">
                <FormattedMessage id="common.label.accept" />
              </span>
            </TextStyle>
          </div>
          <div
            className="chatPromptButton flex-center declinePrompt ptr"
            onClick={() => sendValue(false)}
          >
            <TextStyle>
              <span className="text-white">
                <FormattedMessage id="asset.details.patch.rejectBtn" />
              </span>
            </TextStyle>
          </div>
        </ButtonGroup>
      </div>
    </div>
  );
}

export default ChatPromptModal;
